import { render, staticRenderFns } from "./SlideUpButton.vue?vue&type=template&id=2b34ba59"
import script from "./SlideUpButton.vue?vue&type=script&lang=js"
export * from "./SlideUpButton.vue?vue&type=script&lang=js"
import style0 from "./SlideUpButton.vue?vue&type=style&index=0&id=2b34ba59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports